import { useNavigate } from 'react-router-dom'

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { MODULES, useModules } from '@/hooks/useModules'

export type OrdersSpaceTab = 'orders' | 'suppliers' | 'mailboxes'

const TAB_PATH: Record<OrdersSpaceTab, string> = {
  orders: '/supplier-orders',
  suppliers: '/supplier-orders/suppliers',
  mailboxes: '/supplier-orders/mailboxes',
}

/**
 * SOLY-SUPPLIER-002 — the pages of the orders space: the orders board, the suppliers page and, when
 * Soly switched the module on, the Outlook mailboxes. The tabs are routes (each page keeps its own URL,
 * its own back button), not panels of one page.
 */
export function OrdersSpaceTabs({ active }: { active: OrdersSpaceTab }) {
  const navigate = useNavigate()
  const { hasModule } = useModules()
  return (
    <Tabs value={active} onValueChange={(v) => navigate(TAB_PATH[v as OrdersSpaceTab])}>
      <TabsList>
        <TabsTrigger value="orders" data-testid="orders-space-orders-tab">
          Commandes
        </TabsTrigger>
        <TabsTrigger value="suppliers" data-testid="orders-space-suppliers-tab">
          Fournisseurs
        </TabsTrigger>
        {hasModule(MODULES.PURCHASE_MAILBOX) && (
          <TabsTrigger value="mailboxes" data-testid="orders-space-mailboxes-tab">
            Boîtes mail
          </TabsTrigger>
        )}
      </TabsList>
    </Tabs>
  )
}
